import { $apiWithoutClient } from 'modules/global';

import { IUserProfileStatsRes } from '../models';

export const getUserProfileStats = (id?: string) => async () => {
  const { data } = await $apiWithoutClient.get<IUserProfileStatsRes[]>(
    `/profile/statistics${id ? `?ids=[${id}]` : ''}`
  );

  return data;
};
